export default function sportsBannerData(api){
    api.provideOMFETopic('subscribeToOddsBannerData', 'unsubscribeFromOddsBannerData', {
        topicName : ({ucsOperatorId, apiVersion, lang, operatorId}) =>
            `/sports/${(apiVersion && ucsOperatorId && apiVersion >= 1 && (ucsOperatorId + '/')) || ''}${lang || 'en'}/sportsBannerData${(!apiVersion || !ucsOperatorId || ( apiVersion < 1)) && `/${operatorId}` || ''}`,
    });
}



// WEBPACK FOOTER //
// ./src/OMFECore/enhanced-webapi/api-sports/sub-sports-banner-data.js